export default "__VITE_ASSET__fc1cc952__"